/* MolCellQuest — 期間限定キャンペーン
   ──────────────────────────────────────────────────────────
   終了日を過ぎたら自動的に消える。告知を出しっぱなしにして
   「もう終わったキャンペーンが表示され続ける」のを防ぐため、
   表示条件はここ一か所だけで決める。
   終わったら CAMPAIGN.active を false にするか、この定義ごと消せばよい。
   ────────────────────────────────────────────────────────── */

export const CAMPAIGN = {
  active: true,
  em: "🥤",
  title: "新規登録で好きなドリンク買います！",
  note: "LINEでスクショを送ってください",
  /** 締切（この日の終わりまで有効） */
  endsAt: new Date("2026-07-31T23:59:59+09:00"),
  endLabel: "7/31まで",
};

export function campaignActive() {
  return CAMPAIGN.active && Date.now() <= CAMPAIGN.endsAt.getTime();
}

/** 締切まであと何日か（今日ぶんを含む）。0 なら「今日まで」。 */
export function campaignDaysLeft() {
  const ms = CAMPAIGN.endsAt.getTime() - Date.now();
  if (ms <= 0) return -1;
  return Math.floor(ms / 86400000);
}

/** バッジに出す残り期間の文言 */
export function campaignLeftLabel() {
  const d = campaignDaysLeft();
  if (d < 0) return "";
  if (d === 0) return "今日まで！";
  return `あと${d}日`;
}
